import React from 'react';
import { Avatar, Icon, Menu, Dropdown } from 'antd';
import { googleLogout } from '@react-oauth/google';

import styles from './Header.module.scss';

const UserAvatar = ({ history, profile, userLogout }) => {
  const redirectToHome = () => history.push('/');

  return (
    <Dropdown
      overlay={<UserButtonDropdownMenu redirectToHome={redirectToHome} userLogout={userLogout} />}
      trigger={['click']}
      placement="bottomCenter"
    >
      <div className={styles.userButtonWrapper}>
        <Avatar className={styles.avatar} src={profile.picture} />
        <span>{profile.name}</span>
      </div>
    </Dropdown>
  );
};

const UserButtonDropdownMenu = props => {
  const { redirectToHome, userLogout, ...rest } = props;

  const handleLogout = () => {
    googleLogout();

    userLogout();
    redirectToHome();
  };

  return (
    <Menu {...rest}>
      <Menu.Item key="logout" onClick={handleLogout}>
        <Icon type="logout" />
        <span>Log out</span>
      </Menu.Item>
    </Menu>
  );
};

export default UserAvatar;
